module.exports = __webpack_public_path__ + "static/media/basicKit__mechanism.84036d3b.jpg";